module.exports = __webpack_public_path__ + "static/media/children6-13years.ce6a7ef6.svg";